import { ICON_KEY } from '../../icons/icons';
import { SocialButton } from '../models';

export const PLATO_SOCIAL_BUTTONS: SocialButton[] = [
    {
        name: 'soundcloud',
        icon: ICON_KEY.SOUNDCLOUD,
        link: 'https://soundcloud.com/radioplato',
    },
    {
        name: 'bandcamp',
        icon: ICON_KEY.BANDCAMP,
        link: 'https://radioplato.bandcamp.com',
    },
    {
        name: 'spotify',
        icon: ICON_KEY.SPOTIFY,
        link: 'https://open.spotify.com/user/llh1ub9gwdw5cpczlzz8mu27b',
    },
    {
        name: 'youtube',
        icon: ICON_KEY.YOUTUBE,
        link: 'https://www.youtube.com/@radioplato',
    },
    {
        name: 'email',
        icon: ICON_KEY.EMAIL,
        link: 'mailto:hey@radioplato.live',
    },
    {
        name: 'instagram',
        icon: ICON_KEY.INSTAGRAM,
        link: 'https://www.instagram.com/radio_plato',
    },
    {
        name: 'telegram',
        icon: ICON_KEY.TELEGRAM,
        link: 'https://t.me/radioplato',
    },
    {
        name: 'facebook',
        icon: ICON_KEY.FACEBOOK,
        link: 'https://www.facebook.com/radioplato.live',
    },
];